import { Constants } from '@leverege/api-redux';
import { createSelectors } from '@leverege/ui-redux';
export const plugin = {
  id: 'molten.UnifiedHistoryInit',
  sort: -10,
  createReducers: molten => {
    return {
      unifiedHistory: unifiedHistoryReducer
    };
  }
};
const defaultState = {};
const EXPIRATION_TIME = 1000 * 60 * 5; // 5 minutes

// eslint-disable-next-line default-param-last
function unifiedHistoryReducer(state = defaultState, action) {
  if (action.type === Constants.INTERFACE_GET_HISTORY) {
    const loadedAt = Date.now();
    const items = action?.data?.items;
    if (items) {
      const nState = {
        ...state
      };
      items.forEach(item => {
        if (item.id) {
          nState[item.id] = {
            ...nState[item.id],
            ...item,
            loadedAt // Add timestamp to allow for expiration
          };
        }
      });
      Object.entries(nState).forEach(([key, value]) => {
        if (hasExpired(value)) {
          delete nState[key];
        }
      });
      if (action.queryName) {
        nState[action.queryName] = items;
      }
      return nState;
    }
  }
  return state;
}
function get(state, recordId) {
  return state[recordId];
}
unifiedHistoryReducer.createSelectors = (key, createSetStateKey = false) => {
  return createSelectors('unifiedHistory', {
    get
  }, createSetStateKey);
};
const selectors = unifiedHistoryReducer.createSelectors('unifiedHistory', false);
Object.keys(selectors).forEach(key => {
  unifiedHistoryReducer[key] = selectors[key];
});
function hasExpired(item) {
  if (item?.loadedAt && Date.now() - item.loadedAt > EXPIRATION_TIME) {
    return true;
  }
  return false;
}
export default unifiedHistoryReducer;